const browser=browserCheck();
const os=osCheck();
const device=deviceCheck();
$("body").addClass(browser).addClass(os);



$(document).ready(function(){
	
  // <a href="#***">の場合、スクロール処理を追加
  $('a[href*="#"]').click(function() {
		if (location.pathname.replace(/^\//,'') == this.pathname.replace(/^\//,'') && location.hostname == this.hostname) {
  		let $target = jQuery(this.hash);
      $target = $target.length && $target || jQuery('[name="' + this.hash.slice(1) +'"]');
      if ($target.length) {
      	const targetOffset = $target.offset().top;
        $('html,body').animate({ scrollTop: targetOffset }, 800, 'easeOutExpo');//fast
        //$('html,body').animate({ scrollTop: targetOffset }, 1000, 'easeInOutQuart');//smooth
        /*$('html, body').animate({scrollTop: targetOffset/5,opacity: 0}, 300, function() {
					$('html, body').animate({opacity: 1,scrollTop: targetOffset}, 600);
				});//fade scroll*/
        return false;
      }
    }
  });
  
	//Menu
	
  $("#menu-btn").on("click",function(){
	  $("body").toggleClass("menu-open");
  });
  
  //scroll処理
  let scrStart = 0;
  $(window).scroll(function () {
   	let body = window.document.body;
	 	let html = window.document.documentElement;
	 	let scrTop = body.scrollTop || html.scrollTop;
	 	let scrBottom = html.scrollHeight - html.clientHeight - scrTop;
	 	
	 	//ヘッダーメニューのモーション
	 	let scrDef=Math.abs(scrTop - scrStart);
	 	if(scrDef > 30){
		 	if (scrTop > scrStart && scrTop > 63) {
	    	$("header").removeClass("is-show");
	    	$("body").removeClass("menu-open");
		  } else {
		    $("header").addClass("is-show");
		  }
		}
		scrStart = scrTop;
  });
	var logoSlider=$('.logo-loop-list').bxSlider({
		speed:50000,
		ticker: true,
		useCSS: false
	});
  var caseSlider=$('.case-slider-list').bxSlider({
		speed: 800,
		pause: 6000,
		auto: true,
		pager:false,
		nextText:"",
		prevText:"",
		minSlides:1,
		maxSlides:3,
		moveSlides: 1,
		slideMargin: 0,
		controls: true,
		nextSelector:".case-slider-next",
		prevSelector: ".case-slider-prev",
	});
	
	var reportSliderFlag = false;
	var reportSlider;
	$(window).on('load resize', function() {
    reportSliderSet();
  });
	
	function reportSliderSet(){
		var ww = $(window).width();
		if(ww < 768 && !reportSliderFlag){
			reportSlider=$('.report-list').bxSlider({
				speed: 800,
				pause: 6000,
				auto: false,
				pager:false,
				nextText:"",
				prevText:"",
				minSlides:1,
				maxSlides:1,
				moveSlides: 1,
				slideMargin: 0,
				controls: true,
				useCSS:false,
				touchEnabled: false,
			});
			reportSliderFlag = true;
		}else if(ww >= 768 && reportSliderFlag){
			reportSlider.destroySlider();
      reportSliderFlag = false;
		}
	}
	
	
  
  
  //movieを短編合わせにする
	var hh = $('.movie-box').height();
	if (hh * 1.78 >= $('body').width()) {
		//画面縦長
		$('#key .movie-box video,#key .movie-box img ').css('width', hh * 1.78);
		$('#key .movie-box video,#key .movie-box img ').css('height', '100%');
	} else {
	  $('#key .movie-box video,#key .movie-box img ').css('height', $('body').width() * 0.5625);
	  $('#key .movie-box video,#key .movie-box img ').css('width', '100%');
	}
  $(window).on('resize', function () {
		var hh = $('.movie-box').height();
		if (hh * 1.78 >= $('body').width()) {
			//画面縦長
			$('#key .movie-box video,#key .movie-box img ').css('width', hh * 1.78);
			$('#key .movie-box video,#key .movie-box img ').css('height', '100%');
		} else {
		  $('#key .movie-box video,#key .movie-box img ').css('height', $('body').width() * 0.5625);
		  $('#key .movie-box video,#key .movie-box img ').css('width', '100%');
		}
	});
  
  $(".feature-link .clickable").on("click",function(){
	  //console.log($(this).attr("id").substr(0,3));
	  var f=$(this).attr("id").substr(0,3);
	  var fi=$(this).attr("id");
	  $(this).addClass("is-active").siblings(".is-active").removeClass("is-active");
	  $("#"+f+ " li").removeClass("is-show");
	  $("."+fi).addClass("is-show");
  });
  
  $('.feature-box .feature-btn-list a').click(function () {
     var container = $(this).parents('.feature-box');
     var imgContainer = container.find('.image-box');
     var btnList = container.find('.feature-btn-list');
     var index = btnList.find('a').index($(this));
     btnList.find('a').removeClass('active');
     $(this).addClass('active');
     imgContainer.find('.img').removeClass('active');
     imgContainer.find('.img:eq(' + index + ')').addClass('active');
     // setTimeout(function () {
     // }, 600);
   });
  
  $(".faq-q").on("click",function(){
	  $(this).toggleClass("open");
	  $(this).next(".faq-a").slideToggle(300);  
	});
	
	
	//モーダル
	$(".modal").click(function () {
    //導入事例
    var target = $(this).attr('modaltarget');
    var blockName="";
    
    if(target=="reportDetail"){
	    $(".modalArea .modal-box").removeClass("active");
	    blockName=$(this).attr('blockname');
	    $(".modalArea ."+blockName).addClass("active");
    }
    
    $('.modalArea').show().animate({
      opacity: 1
    }, 400, function () {
      $('.modalArea .item.' + target).fadeIn().addClass('active');
      $('.modalArea .inner').addClass("active");
      //bodyのスクロール防止
	
	    scrollpos = $(window).scrollTop();
	    $('header').hide();
	    $('body').addClass('fixed').css({
	      'top': -scrollpos
	    });
	    $('html').addClass('noScroll');
    });
    
  });
  $(".modalArea .closeBtn").click(function () {
    closeModal();
  }); // 余白クリックでモーダルを閉じる
	
	$(document).on("click", function (e) {
    if (e.which === 1) {
      if ($(e.target).closest(".modalArea .contentBox").length === 0) {
        if ($('.modalArea .inner').hasClass('active')) {
          closeModal();
        }
      }
    }
  });
	
});



function closeModal() {
  //bodyのスクロール防止解除
  $('header').show();
  $('body').removeClass('fixed').css({
    'top': ''
  });
  window.scrollTo(0, scrollpos);
  $('.modalArea .inner , .modalArea .item').removeClass('active');
  $('.modalArea').hide();
  $('.modalArea .item').hide();
  $('html').removeClass('noScroll');
}



/*ブラウザ判別*/
function browserCheck(){
	const ua = window.navigator.userAgent.toLowerCase();
	const av = window.navigator.appVersion.toLowerCase();
	if(ua.indexOf('edge') != -1){
		return 'edge';
	}else if (ua.indexOf('opera') != -1) {
  	return 'opera';
	}else if (ua.indexOf("msie") != -1 || ua.indexOf("trident") != -1) {
		$("body").addClass('ie');
  	if (av.indexOf("msie 6.") != -1) {
    	return 'ie6';
  	} else if (av.indexOf("msie 7.") != -1) {
    	return 'ie7';
  	} else if (av.indexOf("msie 8.") != -1) {
    	return 'ie8';
  	} else if (av.indexOf("msie 9.") != -1) {
    	return 'ie9';
  	}else if (av.indexOf("msie 10.") != -1) {
    	return 'ie10';
  	}else if (av.indexOf("rv:11.") != -1) {
    	return 'ie11';
  	}
	} else if (ua.indexOf('chrome') != -1) {
  	return 'chrome';
	} else if (ua.indexOf('safari') != -1) {
  	return 'safari';
	} else if (ua.indexOf('gecko') != -1) {
  	return 'firefox';
	} else {
  	return false;
	}
}

/*OS判別*/
function osCheck(){
	const ua = window.navigator.userAgent.toLowerCase();
	if (ua.indexOf('windows') != -1) {
		if(ua.indexOf('phone') != -1){
			return 'winphone';
		}else{
			return 'win';
		}
	}else if(ua.indexOf('iphone') != -1) {
		return 'iphone';
	}else if(ua.indexOf('ipad') != -1) {
		return 'ipad';
	}else if(ua.indexOf('mac') != -1) {
		return 'mac';
	}else if(ua.indexOf('android') != -1) {
		if(ua.indexOf('mobile') != -1){
			if(ua.indexOf('A1_07') != -1){
				return 'tablet';
			}else if(ua.indexOf('SC-01C') != -1){
				return 'tablet';
			}else{	return 'android';}
		}else{
			return 'tablet';
		}
	}else{
		return false;
	}
}

/*デバイス判別*/
function deviceCheck(){
	const ua = window.navigator.userAgent.toLowerCase();
	if((ua.indexOf("windows") != -1 && ua.indexOf("touch") != -1 && ua.indexOf("tablet pc") == -1) 
      || ua.indexOf("ipad") != -1
      || (ua.indexOf("android") != -1 && ua.indexOf("mobile") == -1)
      || (ua.indexOf("firefox") != -1 && ua.indexOf("tablet") != -1)
      || ua.indexOf("kindle") != -1
      || ua.indexOf("silk") != -1
      || ua.indexOf("playbook") != -1){
      return 'tab';
    }else if((ua.indexOf("windows") != -1 && ua.indexOf("phone") != -1)
      || ua.indexOf("iphone") != -1
      || ua.indexOf("ipod") != -1
      || (ua.indexOf("android") != -1 && ua.indexOf("mobile") != -1)
      || (ua.indexOf("firefox") != -1 && ua.indexOf("mobile") != -1)
      || ua.indexOf("blackberry") != -1){
	    return 'sp';
    }else{
      return 'pc';
    }
}